const REPLACE_PATTERN = /[_-]([a-z])/g;
module.exports = (jsonObject) => Object.keys(jsonObject).reduce((acc, key) => {
  const camelCaseKey = key.replace(REPLACE_PATTERN, (g) => g[1].toUpperCase());

  acc[camelCaseKey] = jsonObject[key];

  return acc;
}, {});
